import { getConfigJson } from '@/views/contactPerson/api'
import { get_access_token } from '@/router/api'
import Vue from 'vue'
import { Toast } from 'vant'
import util from '@/libs/util.js'
import { set } from 'lodash'
import auth from '@/utils/auth'
import clientConfig from '@/config/clientConfig' // 导入clientConfig

Vue.use(Toast)
export default {
   namespaced: true,
   state: {
      // 联系人tab list
      contact_person_tab_list: [],

      //获取access_token的参数 app_secret and appid
      uri_param: {},
   },
   actions: {
      /**
       * @description 请求前端配置文件 - 优化使用clientConfig
       * @param {Object} context
       */
      async get_config_json({ state, dispatch }, query) {
         try {

            console.log('解码前client_id:', query.client_id);
            const client_id = util.localStorage.get('client_id') || (query && atob(window.decodeURI(query.client_id)))
            console.log('解码后client_id:', client_id);
            // 优先使用clientConfig获取配置
            try {
               console.log('使用clientConfig获取配置')
               const config = clientConfig.getClientConfig()
               
               // 处理contact_person_tab_list
               if (client_id && config.client) {
                  const clientItem = config.client.find(c => String(c.client_id) === String(client_id))
                  
                  if (clientItem && clientItem.contact_person_tab_list) {
                     await dispatch('set_contact_person_tab_list', clientItem.contact_person_tab_list)
                  }
               }
               
               // 检查是否已有token，如果有则跳过token参数设置
               const hasToken = util.cookies.get('Access_Token')
               if (hasToken) {
                  console.log('已有token，仅缓存参数不触发token获取')
                  // 只缓存参数，不调用getAccessToken
                  util.localStorage.set('app_secret', config.app_secret)
                  util.localStorage.set('appid', config.appid)
                  
                  // store赋值
                  state.uri_param = {
                     app_secret: config.app_secret,
                     appid: config.appid
                  }
               } else {
                  // 没有token时才设置token参数并获取token
               await dispatch('set_token_param', {
                  app_secret: config.app_secret,
                  appid: config.appid,
               })
               }
               
               return config
            } catch (err) {
               console.warn('clientConfig获取失败，使用网络请求', err)
            }
            
            // 回退到网络请求
            let res = await getConfigJson()
            
            for (let i = 0; i < res.client.length; i++) {
               if (res.client[i].client_id == client_id) {
                  await dispatch(
                     'set_contact_person_tab_list',
                     res.client[i].contact_person_tab_list
                  )
               }
            }

            await dispatch('set_token_param', {
               app_secret: res.app_secret,
               appid: res.appid,
            })
            
            return res
         } catch (error) {
            console.error('获取配置信息失败:', error)
            throw error
         }
      },

      /**
       * @description 设置联系人tablist
       * @param {Object} context
       * @param {*} info info
       */
      async set_contact_person_tab_list({ state, dispatch }, info) {
         // store 赋值
         state.contact_person_tab_list = info

         // 持久化
         await dispatch(
            'tccc/db/set',
            {
               dbName: 'sys',
               path: 'configuration.contact_person_tab_list',
               value: info,
               user: true,
            },
            { root: true }
         )
      },

      /**
       * @description 设置app_secre和appid
       * @param {Object} context
       * @param {*} info info
       */
      async set_token_param({ state, dispatch }, info) {
         // 缓存app_secret appid
         util.localStorage.set('app_secret', info.app_secret)
         util.localStorage.set('appid', info.appid)

         // 检查是否已有token
         const token = util.cookies.get('Access_Token')
         if (token) {
            console.log('已有token，跳过getAccessToken调用')
         } else {
            // 只有在没有token时才尝试获取
         try {
               await dispatch('getAccessToken', info)
         } catch (error) {
               console.error('Token获取失败，将在页面加载后重试', error)
            // 失败不阻塞
            }
         }

         // store 赋值
         state.uri_param = info

         // 持久化
         await dispatch(
            'tccc/db/set',
            {
               dbName: 'sys',
               path: 'configuration.uri_param',
               value: info,
               user: true,
            },
            { root: true }
         )
      },

      /**
       * @description 获取Access_Token
       * @param {Object} context
       * @param {Object} payload
       * @modified 修改为使用新的Token服务
       */
      async getAccessToken({ state, dispatch }, { appid, app_secret }) {
         try {
            // 检查是否已有有效token
            const token = util.cookies.get('Access_Token');
            if (token) {
               console.log('已有token，跳过获取');
               return { token }; // 直接返回现有token
            }
            
            // 使用initTokenService替代直接调用refreshToken
            await auth.initTokenService('vuex.getAccessToken');
            
            // 获取初始化后的token
            const newToken = util.cookies.get('Access_Token');
            if (newToken) {
               return { token: newToken };
            }
            
            // 如果还是没有token，才直接调用refreshToken
            return await auth.refreshToken('vuex.getAccessToken.fallback');
         } catch (error) {
            Toast.fail(error.message || '获取Token失败');
            throw error;
         }
      },

      /**
       * @description 从数据库取设置数据
       * @param {Object} context
       */
      async load({ state, dispatch }) {
         let uri_param = await dispatch(
            'tccc/db/get',
            {
               dbName: 'sys',
               path: 'configuration.uri_param',
               defaultValue: [],
               user: true,
            },
            { root: true }
         )
         // store 赋值
         state.uri_param = uri_param

         let contact_person_tab_list = await dispatch(
            'tccc/db/get',
            {
               dbName: 'sys',
               path: 'configuration.contact_person_tab_list',
               defaultValue: [],
               user: true,
            },
            { root: true }
         )
         // store 赋值
         state.contact_person_tab_list = contact_person_tab_list
      },
   },
}